export const getErrorMessage = (error: any): string => {
  const data = error.response?.data;
  if (!data) return "Une erreur est survenue";
  
  if (typeof data === "string") return data;
  
  if (data.detail) return data.detail;
  
  if (data.non_field_errors && Array.isArray(data.non_field_errors)) {
      return data.non_field_errors.join(", ");
  }
  
  // validation errors object
  if (typeof data === "object") {
    // Return first error found or generic message
    const keys = Object.keys(data);
    if (keys.length > 0) {
        const firstKey = keys[0];
        const firstError = data[firstKey];
        if (Array.isArray(firstError)) return `${firstKey}: ${firstError[0]}`;
        if (typeof firstError === "string") return `${firstKey}: ${firstError}`;
    }
  }
  
  return "Une erreur inconnue est survenue";
};
